import useSWR from 'swr'
import { authCall } from '.'
import {
  addResidentType,
  enableDisableResidentAction,
  estateResidents,
  residentAccessLogs,
  residentMembership,
  residents,
  residentType,
  updateResidentType,
} from './endpoints'
import {
  IResidentList,
  IAddResident,
  ResidentDTO,
  CustomPaginationQuery,
  IResidentTypeList,
  ResidentTypeDTO,
  CreateResidentTypeDTO,
  UpdateResidentTypeDTO,
  DisableResApiResponse,
  RemoveResidentResponse,
  ResidentMembershipResponse,
  ResidentAccessLogsResponse,
} from '../interfaces/resident'

const ResidentService = {
  useGetResidentList: ({
    page = 1,
    size = 15,
    search = '',
  }: CustomPaginationQuery & { search?: string }) => {
    const query = new URLSearchParams({
      page: String(page),
      limit: String(size),
    })
    if (search) query.append('search', search)

    const url = `${estateResidents}?${query.toString()}`
    return useSWR(url, () => {
      return authCall<IResidentList>({
        url,
        method: 'get',
      })
    })
  },

  addResident: (data: IAddResident) => {
    const url = estateResidents
    return authCall<ResidentDTO>({
      url,
      data,
      method: 'post',
    })
  },

  useGetResidentTypeList: (
    estateId: string,
    { page = 1, size = 15 }: CustomPaginationQuery
  ) => {
    const url = `${residentType(estateId)}?page=${page}&limit=${size}`
    return useSWR(url, () => {
      return authCall<IResidentTypeList>({
        url,
        method: 'get',
      })
    })
  },

  removeResident: (residentId: string) => {
    const url = `${residents}/${residentId}`
    return authCall<RemoveResidentResponse>({
      url,
      method: 'delete',
    })
  },

  useGetResidentType: ({ estateId }: { estateId: string }) => {
    const url = residentType(estateId)
    return useSWR(url, () => {
      return authCall<ResidentTypeDTO>({
        url,
        method: 'get',
      })
    })
  },

  addResidentType: (estateId: string, data: CreateResidentTypeDTO) => {
    const url = addResidentType(estateId)
    return authCall<CreateResidentTypeDTO>({
      url,
      data,
      method: 'post',
    })
  },

  updateResidentType: (
    estateId: string,
    residentTypeId: string,
    data: UpdateResidentTypeDTO
  ) => {
    const url = updateResidentType(estateId, residentTypeId)
    return authCall({
      url,
      data,
      method: 'patch',
    })
  },

disableOrEnableResident: (
  residentId: string | undefined,
  disableOrEnableAction: 'disable' | 'enable',
  payload?: {
    reason?: string
    validUntil?: string
    indefinite?: boolean
  }
) => {
  const url = `${estateResidents}/${residentId}/${disableOrEnableAction}`

  const data =
    disableOrEnableAction === 'disable'
      ? {
          ...payload,
          reason: payload?.reason
        }
      : {
          ...payload
        }

  return authCall<DisableResApiResponse>({
    url,
    method: 'put',
    data
  })
},
useGetResidentMembership: (communityMemberId: string) => {
  const url = residentMembership(communityMemberId)

  return useSWR<ResidentMembershipResponse>(
    communityMemberId ? url : null,
    async () => {
      const response = await authCall({
        url,
        method: 'get',
      })

      return response as ResidentMembershipResponse
    },
  )
},

useUpdateResidentAccess: () => {
  const updateResidentAccess = async (
    propertyMemberId: string,
      action:
      | 'enabled'
      | 'disabled'
      | 'indefinite',
     data?: {
       enabledUntil?: string
      enabledAt?: string
      amount?: string
      reason?: string
    }
  ) => {
    const url = enableDisableResidentAction(
      propertyMemberId,
      action
    )

    const response = await authCall({
      url,
      method: 'patch',
      data,
    })

    console.log('Resident Access Action Response:', response)

    return response
  }

  return {
    updateResidentAccess,
  }
},

useGetResidentAccessLogs: (propertyMemberId?: string) => {
  const url = propertyMemberId
    ? residentAccessLogs(propertyMemberId)
    : null

  return useSWR<ResidentAccessLogsResponse>(
    url,
    async () => {
      const response = await authCall({
        url: url!,
        method: 'get',
      })

      console.log(
        'Resident Access Logs API Response:',
        response,
      )

      return response as ResidentAccessLogsResponse
    },
  )
},
  
}

export default ResidentService
